import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Customer from './pages/Customer';
import CustomerUpdate from './components/Update Forms/CustomerUpdate';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import SignUp from './pages/SignUp';
import axios from 'axios';
import { useSelector } from 'react-redux';
import ErrorPage from './pages/ErrorPage';
import CreateCustomer from './components/Create Forms/CreateCustomer';
import Product from './pages/Product';
import Users from './pages/Users';
import Invoice from './pages/Invoice';
import AllCustomer from './components/DisplayDetails/AllCustomer';
import CreateUser from './components/Create Forms/CreateUser';
import UpdateUser from './components/Update Forms/UpdateUser';
import AllUser from './components/DisplayDetails/AllUser';
import CreateProduct from './components/Create Forms/CreateProduct';
import AllProducts from './components/DisplayDetails/AllProducts';
import ProductUpdate from './components/Update Forms/ProductUpdate';
import RentUpdate from './components/Update Forms/RentUpdate';
import Category from './pages/Category';
import AllCategories from './components/DisplayDetails/AllCategories';
import CategoryUpdate from './components/Update Forms/CategoryUpdate';
import CreateCategory from './components/Create Forms/CreateCategory';
import CreateBuying from './components/Create Forms/CreateBuying';
import BuyingUpdate from './components/Update Forms/BuyingUpdate';
import AllBuying from './components/DisplayDetails/AllBuying';
import Buying from './pages/Buying';
import Sell from './pages/Sell';
import AllSell from './components/DisplayDetails/AllSell';
import CreateSell from './components/Create Forms/CreateSell';
import SoldData from './pages/SoldData';
import ViewBuying from './components/DisplayDetails/ViewBuying';
import CreateSell2 from './components/Create Forms/CreateSell2';
import ProtectedRoute from './pages/ProtectedRoute';
import Footer from './components/Footer';
import Bank from './pages/Bank';



function App() {

  const { token } = useSelector(state => state.user);

  axios.defaults.baseURL = process.env.REACT_APP_BASEURL;
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  axios.defaults.withCredentials = true;

  return (
    <>
      <BrowserRouter>

        <Navbar />

        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/signup' element={<SignUp />} />
          <Route path='*' element={<ErrorPage />} />


          <Route path='/sold-data/:id' element={<SoldData />} />

          {/* layout for customer....... */}
          <Route path='/customer' element={<ProtectedRoute><Customer /></ProtectedRoute>}>
            <Route index element={<AllCustomer />} />
            <Route path='update/:id' element={<CustomerUpdate />} />
            <Route path='add' element={<CreateCustomer />} />

          </Route>

          <Route path='/selling' element={<ProtectedRoute><Sell /></ProtectedRoute>}>
            <Route index element={<AllSell />} />
            <Route path='create/:id' element={<CreateSell />} />
            <Route path='create2/:id' element={<CreateSell2 />} />
            <Route path='update/:id' element={<RentUpdate />} />

          </Route>

          <Route path='/product' element={<ProtectedRoute><Product /></ProtectedRoute>}>
            <Route index element={<AllProducts />} />
            <Route path='update/:id' element={<ProductUpdate />} />
            <Route path='add' element={<CreateProduct />} />
          </Route>


          <Route path='/users' element={<ProtectedRoute><Users /></ProtectedRoute>}>
            <Route index element={<AllUser />} />
            <Route path='update/:id' element={<UpdateUser />} />
            <Route path='add' element={<CreateUser />} />
          </Route>

          <Route path='/category' element={<ProtectedRoute><Category /></ProtectedRoute>}>
            <Route index element={<AllCategories />} />
            <Route path='update/:id' element={<CategoryUpdate />} />
            <Route path='add' element={<CreateCategory />} />
          </Route>

          <Route path='/buying' element={<ProtectedRoute><Buying /></ProtectedRoute>}>
            <Route index element={<AllBuying />} />
            <Route path='update/:id' element={<BuyingUpdate />} />
            <Route path='add' element={<CreateBuying />} />
            <Route path='view/:id' element={<ViewBuying />} />
          </Route>

          <Route path='invoice/:id' element={<ProtectedRoute><Invoice /></ProtectedRoute>} />

          <Route path='/bank' element={<Bank />} />

        </Routes>

        <Footer />


      </BrowserRouter>
    </>
  );
}

export default App;
